import axios from '../../config/axiosConfig';
import { CREATE_PROCESS_TYPE, GET_PROCESS_TYPE, PROCESS_TYPE_REQUEST, DELETE_PROCESS_TYPE, 
UPDATE_PROCESS_TYPE, PROCESS_TYPE_REQUEST_FAILURE, GET_PROCESS_TYPE_PAGE } from '../types';
import { addMasterInOption, updateMasterInOption } from './master-options-actions';

export const getProcessTypesWithPagination = (page, limit, include, searchStr, searchCols, where, addTotal) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PROCESS_TYPE_REQUEST });
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id,
        page, limit, include, addTotal, search: searchStr, searchCols, where,
      };
      return axios.get("/process-type/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_PROCESS_TYPE_PAGE, payload: { ...response.data, where } });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PROCESS_TYPE_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PROCESS_TYPE_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getProcessTypes = (commonMaster) => {
    return async (dispatch, getState) => {
        try {
            dispatch({ type: PROCESS_TYPE_REQUEST });
            const { auth } = getState();
            let params = { customerId: auth?.user?.Customer_Id };
            if (!auth?.company?.Common_Master) {
                params = { ...params, companyId: auth.company?.id }
            }
            if (commonMaster !== undefined) {
                params = {
                  ...params,
                  companyId: commonMaster ? undefined : auth.company?.id
                };
            }
            return axios.get('/process-type/getAll', { params }).then((response) => {
                if (response.data) {
                    dispatch({ type: GET_PROCESS_TYPE, payload: response.data });
                }
            }).catch((error) => {
                console.error(error);
                dispatch({ type: PROCESS_TYPE_REQUEST_FAILURE, error: error.message });
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: PROCESS_TYPE_REQUEST_FAILURE, error: error.message });
        }
    };
};

export const createProcessType = (data) => {
    return async (dispatch, getState) => {
        try {
            const { auth } = getState();
            const { processTypes } = getState();
            dispatch({ type: PROCESS_TYPE_REQUEST });

            return axios.post('/process-type/add', data,
                { params: { userId: auth.user?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id }}).then( async (response) => {
                    if (response.data) {
                        dispatch({ type: CREATE_PROCESS_TYPE, payload: response.data });
                        // Re-fetch the current page to get updated data
                        await dispatch(getProcessTypesWithPagination(
                            processTypes.page || 1,           // current page
                            processTypes.pageSize || 10,      // current page size
                            undefined,                  // include
                            processTypes.search || '',        // current search
                            undefined,                  // searchCols
                            processTypes.where || {},         // current filters
                            true                        // addTotal
                        ));
                        dispatch(addMasterInOption('processTypes', response.data));
                    } else {
                        dispatch({ type: PROCESS_TYPE_REQUEST_FAILURE, error: 'Process Type create failed.' });
                    }
                    return response;
                }).catch((error) => {
                    console.error(error);
                    dispatch({ type: PROCESS_TYPE_REQUEST_FAILURE, error: error.message });
                    throw error;
                });
        } catch (error) {
            console.error(error);
            dispatch({ type: PROCESS_TYPE_REQUEST_FAILURE, error: error.message });
            throw error;
        }
    };
};

export const updateProcessType = (id, data) => {
    return async (dispatch, getState) => {
        try {
            const { auth } = getState();
            const { processTypes } = getState();
            dispatch({ type: PROCESS_TYPE_REQUEST });
            return axios.put('/process-type/update', { id, data }, { params: { userId: auth.user?.id }}).then( async (response) => {
                if (response.data) {
                    dispatch({ type: UPDATE_PROCESS_TYPE, payload: { id, data: response.data } });
                    // Re-fetch the current page to get updated data
                    await dispatch(getProcessTypesWithPagination(
                        processTypes.page || 1,           // current page
                        processTypes.pageSize || 10,      // current page size
                        undefined,                  // include
                        processTypes.search || '',        // current search
                        undefined,                  // searchCols
                        processTypes.where || {},         // current filters
                        true                        // addTotal
                    ));
                    dispatch(updateMasterInOption('processTypes', id, response.data));
                } else {
                    dispatch({ type: PROCESS_TYPE_REQUEST_FAILURE, error: 'Process Type update failed.' });
                }
                return response;
            }).catch((error) => {
                console.error(error);
                dispatch({ type: PROCESS_TYPE_REQUEST_FAILURE, error: error.message });
                throw error;
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: PROCESS_TYPE_REQUEST_FAILURE, error: error.message });
            throw error;
        }
    };
};

export const deleteProcessType = (id) => {
    return async (dispatch, getState) => {
        try {
            const { processTypes } = getState();
            dispatch({ type: PROCESS_TYPE_REQUEST });
            return axios.delete(`/process-type/delete/${id}`).then( async (response) => {
                if (response.data) {
                    dispatch({ type: DELETE_PROCESS_TYPE, id: id });
                    // Re-fetch the current page to get updated data
                    await dispatch(getProcessTypesWithPagination(
                        processTypes.page || 1,           // current page
                        processTypes.pageSize || 10,      // current page size
                        undefined,                  // include
                        processTypes.search || '',        // current search
                        undefined,                  // searchCols
                        processTypes.where || {},         // current filters
                        true                        // addTotal
                    ));
                    dispatch(updateMasterInOption('processTypes', id));
                }
                return response;
            }).catch((error) => {
                console.error(error);
                dispatch({ type: PROCESS_TYPE_REQUEST_FAILURE, error: error.message });
                throw error;
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: PROCESS_TYPE_REQUEST_FAILURE, error: error.message });
            throw error;
        }
    };
};